import { usePageStateMemory } from "./usePageStateMemory.js";

function normalizeSortState(value) {
  if (!value || typeof value !== "object") {
    return null;
  }

  const key = typeof value.key === "string" ? value.key : "";
  const direction = value.direction === "asc" || value.direction === "desc"
    ? value.direction
    : null;

  if (!key || !direction) {
    return null;
  }

  return { key, direction };
}

export function useRememberedSortState(sessionKey) {
  return usePageStateMemory(sessionKey, null, {
    deserialize: (storedValue) => {
      try {
        return normalizeSortState(JSON.parse(storedValue));
      } catch {
        return null;
      }
    },
    serialize: (sortState) => JSON.stringify(sortState),
    removeWhen: (sortState) => !sortState
  });
}
